import React, { useEffect, useState } from 'react';
import { createGesture, IonContent, IonFooter, IonPage } from '@ionic/react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import { sidnavStore, SidenavState } from '../api/SidenavStore';
import { ApiService } from '../api/ApiService';
import { UserUtils } from '../utils/UserUtils';
import PayFirstIn from '../components/walkthrough/PayFirstIn';
import HeroChrome from '../components/HeroChrome';
import { CalendarIcon } from '../components/icons';
import { FaqSvg, FuelSvg, MoneySvg } from '../components/svgIcons';
import { config } from '../Constants';
import { runStatus } from '../components/walkthrough/FirstSignIn';

function useMoneyData() {
  const [mounted, setMounted] = useState(false);
  const [msgCount, setMsgCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    ApiService.sendEventCommand('Money', 'eventCheck', 'User viewed the Money page');

    ApiService.chatConversationGet('money', {})
      .then((it: any) => {
        if (!Array.isArray(it)) return;
        let count = 0;
        for (let i = 0; i < it.length; i++) {
          if (it[i]?.lastMessage?.read !== 1) count += 1;
        }
        setMsgCount(count);
      })
      .catch(() => {});

    if (!UserUtils.isAdmin() && !UserUtils.isDriverManager() && !UserUtils.isInspector()) {
      ApiService.getPushNotifications('money')
        .then((it: any) => {
          if (!Array.isArray(it)) return;
          setNotificationCount(it.filter((notification: any) => !notification.read).length);
        })
        .catch(() => {});
    }
  }, []);

  return { mounted, msgCount, notificationCount };
}

const Money = () => {
  const { close }: { close: () => void } = sidnavStore((state: SidenavState) => ({
    open: state.open,
    close: state.close,
  }));
  const { toggleSidenav }: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({
    toggleSidenav: state.toggle,
  }));

  const ref = React.useRef<HTMLDivElement>(null);
  const moneyData = useMoneyData();

  useEffect(() => {
    if (config.showSidenav) gestureInit();
  }, []);

  const gestureInit = () => {
    const card = ref.current;
    if (!card) return;
    const gesture = createGesture({
      el: card,
      gestureName: 'swipeMenu',
      onMove: () => {},
      onEnd: () => {
        runStatus ? console.log('locked') : toggleSidenav();
      },
    });
    gesture.enable();
  };

  return (
    <IonPage>
      <IonContent fullscreen className="design-a-content">
        <PayFirstIn>
          <div
            ref={ref}
            className={`design-a${moneyData.mounted ? ' design-a--mounted' : ''}`}
            onClick={() => close()}
          >
            <div className="home-hero">
              <HeroChrome
                onMenuClick={() => toggleSidenav()}
                msgCount={moneyData.msgCount}
                notificationCount={moneyData.notificationCount}
              />

              <div className="pay-hero">
                <div className="pay-hero__badge">
                  <MoneySvg color="#ffffff" size={32} />
                </div>
                <div className="pay-hero__title home-display">Pay &amp; Settlements</div>
                <div className="pay-hero__subtitle">Settlements, fuel &amp; deferments</div>
              </div>
            </div>

            <div className="home-sheet">
              <div className="pay-tile-grid" id="WholeMoneySection">
                <Link to="/settlements" className="pay-tile">
                  <div className="pay-tile__icon">
                    <MoneySvg />
                  </div>
                  <div className="pay-tile__title">Settlements</div>
                </Link>

                <Link to="/deferment" className="pay-tile">
                  <div className="pay-tile__icon">
                    <CalendarIcon size={22} />
                  </div>
                  <div className="pay-tile__title">Deferment</div>
                </Link>

                <Link to="/fuelreceipts" className="pay-tile">
                  <div className="pay-tile__icon">
                    <FuelSvg />
                  </div>
                  <div className="pay-tile__title">Fuel Receipts</div>
                  <div className="pay-tile__tag">Upload photos</div>
                </Link>

                <Link to="/payrollfaq" className="pay-tile" id="WestLinks">
                  <div className="pay-tile__icon">
                    <FaqSvg />
                  </div>
                  <div className="pay-tile__title">Settlements FAQ</div>
                </Link>
              </div>
            </div>
          </div>
        </PayFirstIn>
      </IonContent>
      <IonFooter>
        <Nav
          pageName="Money"
          onSearch={function (target: boolean): void {
            console.log('Not ready');
          }}
        />
      </IonFooter>
    </IonPage>
  );
};

export default Money;
